module.exports = __webpack_public_path__ + "img/07.32f5d7f.png";